// extracted by mini-css-extract-plugin
export default {"main":"layout-module--main--Pw-Zk","headerPad":"layout-module--header-pad--gi6RE","noMarginTop":"layout-module--no-margin-top--XhxyL"};